import { Component } from '@angular/core';
import { Globals } from '../../../../../globals';
import { NavController } from 'ionic-angular';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OdsViewPage } from '../../../../ods/ods-view/ods-view';
import { TutorialPedidosPage } from '../../../../help/tutorials/tutorial-pedidos/tutorial-pedidos';
import moment from 'moment';

@Component({
    selector: 'page-home-ods',
    templateUrl: 'home-ods.html'
})

export class HomeOdsPage {
    sales_delivery: number = 0;
    total_sales: number = 0;
    visits: number = 0;
    carts: number = 0;
    get_analytics = false;

    constructor(public globals: Globals,
        public navCtrl: NavController,
        public http: HttpClient) {
    }

    ngOnInit() {
        if (this.globals.restaurant.plg_pedidos_finisher == true || this.globals.restaurant.plg_pedidos_finisher == undefined) {
            this.getAnalytics();
        } else {
            this.get_analytics = true
        }
    }

    async getAnalytics() {
        try {
            const params = new HttpParams()
                .set('public_key', this.globals.public_key)
                .set('first_date', moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'))
                .set('last_date', moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'));
            this.http.post(this.globals.analytics_path + 'analytics/delivery_ods', params, {})
                .subscribe(async response => {
                    this.sales_delivery = response['sales'];
                    this.total_sales = response['total_sales'];
                    this.visits = response['visits'];
                    this.carts = response['carts'];
                    this.get_analytics = true;
                });
        } catch (error) {
            this.get_analytics = true
        }
    }

    goToOds() {
        if (this.globals.checkLimitsByLicense('sites', 'sites')) {
            this.globals.side_menu_active = 'web';
            this.navCtrl.setRoot(OdsViewPage);
            this.globals.side_menu_active_analytics = false;
        } else {
            this.globals.side_menu_active = 'web';
            this.globals.side_menu_active_analytics = false;
            this.navCtrl.push(TutorialPedidosPage);
        }
        this.globals.open_side_menu = false;
    }

    openLanding() {
        if (this.globals.so_mobile) {
            window.location.assign('https://landing.mycheftool.com/es/pedidos-online-restaurante');
        } else {
            window.open('https://landing.mycheftool.com/es/pedidos-online-restaurante', '_blank');
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-cards/home-ods/home-ods.ts